import { render, staticRenderFns } from "./normal-input.vue?vue&type=template&id=d45a580c&scoped=true&"
import script from "./normal-input.vue?vue&type=script&lang=js&"
export * from "./normal-input.vue?vue&type=script&lang=js&"
import style0 from "./normal-input.vue?vue&type=style&index=0&id=d45a580c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45a580c",
  null
  
)

export default component.exports